import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function PhoneIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25">
      <g fillRule="evenodd" transform="translate(5 2)">
        <path d="M.2 15.498v-.196c0-.271.222-.502.497-.502h12.606a.5.5 0 0 1 .497.502v.196a.504.504 0 0 1-.497.502H.697a.499.499 0 0 1-.497-.502zM6.2 2.498v-.196c0-.271.222-.502.497-.502h.606a.5.5 0 0 1 .497.502v.196A.504.504 0 0 1 7.303 3h-.606a.499.499 0 0 1-.497-.502M2.285 9.54l-.139-.14a.504.504 0 0 1-.003-.705l4.55-4.55a.5.5 0 0 1 .706.004l.138.139a.503.503 0 0 1 .004.706l-4.55 4.549a.497.497 0 0 1-.706-.003m0-3l-.139-.14a.504.504 0 0 1-.003-.705l1.55-1.55a.5.5 0 0 1 .706.004l.138.139a.503.503 0 0 1 .004.706l-1.55 1.549a.497.497 0 0 1-.706-.003M8 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
        <path d="M1.2 19.8h11.6V1.2H1.2v18.6zM12.993 0H1.007C.449 0 0 .447 0 .999v19.002c0 .552.451.999 1.007.999h11.986c.558 0 1.007-.447 1.007-.999V.999C14 .447 13.549 0 12.993 0z" />
      </g>
    </SvgIcon>
  )
}
